import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import Switch from "@material-ui/core/Switch";
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import { CardMapper } from "features/planner/planner.mappers";
import { showHideEmployee } from "features/planner/employee/employee.actions";
import EmployeeCardHeaderBase from "features/planner/components/EmployeeCardHeaderBase";
import { getEmployeeCardFromState } from "features/planner/employee/employee.selectors";

class EmployeeCardHeader extends PureComponent {
  render() {
    const {
      match,
      classes,
      employeeCard,
      dispatchShowHideEmployee,
    } = this.props;

    return (
      <EmployeeCardHeaderBase employeeCardId={match.params.employeeCardId}>
        <FormControlLabel
          label={
            <Typography variant="body2" noWrap color="inherit">
              Display in Personnel Planner view
            </Typography>
          }
          classes={{
            label: classes.formControlLabel,
          }}
          control={
            <Switch
              checked={!employeeCard.getIn(["employee", "hideInPlanning"])}
              onChange={() => dispatchShowHideEmployee(employeeCard.get("id"))}
            />
          }
        />
      </EmployeeCardHeaderBase>
    );
  }
}

EmployeeCardHeader.defaultProps = {
  employeeCard: CardMapper.initial(),
};

const styles = theme => ({
  formControlLabel: {
    fontWeight: theme.typography.fontWeightMedium,
  },
});

export default compose(
  connect(
    (state, { match }) => ({
      employeeCard: getEmployeeCardFromState(
        state,
        match.params.employeeCardId,
      ),
    }),
    {
      dispatchShowHideEmployee: showHideEmployee,
    },
  ),
  withStyles(styles),
)(EmployeeCardHeader);
